export function getContactSubjects() {
  return (dispatch, _, api) => {
    return api.get('/contact-us/subjects');
  };
}

export function sendContactMessage(postData, headers = {}) {
  return (dispatch, _, api) => {
    return api.post('/contact-us', postData, headers);
  };
}
